<template>
    <footer class="main-footer" style="margin: 0;background-color: #E3EAFD; color: #0F4C96">
      <div class="float-left">
        <strong>Portal BAESSH</strong>
      </div>
      <div class="float-right d-none d-sm-inline-block">
        <b>Versión</b> 3.1
      </div>
    </footer>
</template>

<script>
  export default{
    name: 'FooterPage',
    components: {

    },
  };
</script>
<style>


</style>